import { notify } from "../../event-bus";
import Vue from "vue";
import router from "@/router";

export default {
  namespaced: true,
  state: {
    tables: [],
    tableActiveId: null,
    createdTable: 0
  },
  getters: {
    tables: state => {
      return state.tables;
    },
    tableActive: state => {
      const table = state.tables.find(table => table.id == state.tableActiveId);
      return table ? table : {};
    },
    createdTable: state => {
      return state.createdTable;
    },
    getTable: state => table_name => {
      return state.tables.find(table => table.name === table_name);
    }
  },

  actions: {
    createTable({ commit }, payload) {
      return Vue.http
        .post(`${process.env.VUE_APP_BACKEND_APP}/api/tables`, payload, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Socket-Id": window.Echo.socketId()
          }
        })
        .then(response => {
          const tableData = response.data.table;
          commit("addTable", tableData);
          commit("createdTable", tableData.id);
          return true;
        })
        .catch(error => {
          notify(error, "ERROR");
          return false;
        });
    },
    fetchTables({ commit }, query) {
      return Vue.http
        .get(`${process.env.VUE_APP_BACKEND_APP}/api/tables`, {
          params: query
        })
        .then(response => {
          commit("tablesData", response.data.data);
        })
        .catch(error => {
          notify(error, "ERROR");
        });
    },
    joinTable({ commit }, payload) {
      return Vue.http
        .post(
          `${process.env.VUE_APP_BACKEND_APP}/api/tables/${payload.tableId}/seat`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json"
            }
          }
        )
        .then(() => {
          payload.user = this.state.user.user;
          commit("selectedTable", payload.tableId);
          commit("addUserToTableById", payload);
          router.push("/room");
          return true;
        })
        .catch(error => {
          if (error.status == 422 && error.data.errors.userId) {
            return false;
          }
          if (error.status == 422 && error.data.errors.table_id) {
            return true;
          }
          notify(error, "ERROR");
          return true;
        });
    },
    leaveTable({ commit }, payload) {
      return Vue.http
        .post(
          `${process.env.VUE_APP_BACKEND_APP}/api/tables/standup`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              "X-Socket-Id": window.Echo.socketId()
            }
          }
        )
        .then(() => {
          commit("leaveTable");
          return true;
        })
        .catch(error => {
          if (error.status == 422 && error.data.errors.userId) {
            return false;
          }
          notify(error, "ERROR");
          return true;
        });
    },
    addBot({ commit }, tableId) {
      return Vue.http
        .post(
          `${process.env.VUE_APP_BACKEND_APP}/api/tables/${tableId}/addBot`,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              "X-Socket-Id": window.Echo.socketId()
            }
          }
        )
        .then(() => {
          commit("addUserToTableById", {});
        })
        .catch(error => {
          notify(error, "ERROR");
        });
    },
    replaceBot({ commit }, payload) {
      return Vue.http
        .post(
          `${process.env.VUE_APP_BACKEND_APP}/api/gamequeue/${payload.tableId}/users/${payload.user.id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              "X-Socket-Id": window.Echo.socketId()
            }
          }
        )
        .then(response => {
          commit("selectedTable", payload.tableId);
          if (router.currentRoute.name !== "room") {
            router.push("/room");
          }
          if (response.data.message == "User added to table") {
            commit("addUserToTableById", payload);
            notify(
              "Hai sostituito un robottino e ti sei seduto nel tavolo",
              "SUCCESS"
            );
          } else {
            commit("addUserToQueueById", payload);
            notify("Sei in attesa di entrare nel gioco", "SUCCESS");
          }
          return true;
        })
        .catch(error => {
          notify(error, "ERROR");
          return false;
        });
    },
    removeMeFromQueue({ commit }, payload) {
      return Vue.http
        .delete(
          `${process.env.VUE_APP_BACKEND_APP}/api/gamequeue/${payload.userId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              "X-Socket-Id": window.Echo.socketId()
            }
          }
        )
        .then(() => {
          commit("createdTable", null);
        });
    }
  },
  mutations: {
    tablesData(state, tables) {
      tables.forEach(table => {
        if (table.queue.length > 0) {
          table.queue.forEach(queued => {
            table.users.push(queued);
          });
        }
      });

      state.tables = tables;
    },
    selectedTable(state, tableId) {
      state.tableActiveId = tableId;
    },
    leaveTable(state) {
      state.tableActiveId = null;
    },
    deleteUserFromTablesById(state, payload) {
      var tableIndex = state.tables.findIndex(
        table => table.id == payload.tableId
      );
      var userIndex = state.tables[tableIndex].users.findIndex(
        user => user.id === payload.user.id
      );
      state.tables[tableIndex].users.splice(userIndex, 1);
    },
    addUserToTableById(state, payload) {
      if (!payload.tableId) {
        return;
      }
      var tableIndex = state.tables.findIndex(
        table => table.id == payload.tableId
      );
      if (state.tables[tableIndex].users.length == 5) {
        if (
          state.tables[tableIndex].queue.findIndex(
            user => user.id == payload.user.id
          ) == -1
        ) {
          state.tables[tableIndex].queue.push(payload.user);
        }
      } else {
        if (
          state.tables[tableIndex].users.findIndex(
            user => user.id == payload.user.id
          ) == -1
        ) {
          state.tables[tableIndex].users.push(payload.user);
        }
      }
    },
    addUserToQueueById(state, payload) {
      if (!payload.tableId) {
        return;
      }
      var tableIndex = state.tables.findIndex(
        table => table.id == payload.tableId
      );
      if (
        state.tables[tableIndex].queue.findIndex(
          user => user.id == payload.user.id
        ) == -1
      ) {
        state.tables[tableIndex].queue.push(payload.user);
      }
    },
    addTable(state, payload) {
      const data = {
        users: [],
        queue: [],
        id: payload.id,
        name: payload.name,
        card_type: payload.card_type
      };
      state.tables.push(data);
    },
    createdTable(state, tableId) {
      state.createdTable = tableId;
    },
    removeTable(state, payload) {
      var tableIndex = state.tables.findIndex(table => table.id == payload.id);
      if (
        state.tables[tableIndex].queue.findIndex(
          user => user.id == this.state.user.user.id
        ) != -1
      ) {
        notify(
          "Il gioco è stato abbandonato mentre eri in attesa, scegli un altro tavolo",
          "ERROR"
        );
        router.push("/tables")
      }
      if (tableIndex) {
        state.tables.splice(tableIndex, 1);
      }
    },
    changeBotInUser(state, payload) {
      var tableIndex = state.tables.findIndex(
        table => table.id == state.tableActiveId
      );
      var userIndex = state.tables[tableIndex].users.findIndex(
        user => user.id === payload.botId
      );
      state.tables[tableIndex].users[userIndex].id = payload.user.id;
      state.tables[tableIndex].users[userIndex].name = payload.user.name;
      notify(payload.user.name + " è entrato nel gioco", "SUCCESS");
    },
    resetQueue(state) { 
      var tableIndex = state.tables.findIndex(
        table => table.id == state.tableActiveId
      );
      state.tables[tableIndex].queue = [];
    }
  }
};
